import { useLocation, useNavigate } from "react-router-dom";
import WithTableView from "../../components/withTableView/withTableView";
import Pagination from "../../components/pagination/pagination";
import { useEffect, useState } from "react";
import { deleteByIdApi, getAllApi } from "../../api";
import toast from "react-hot-toast";
import Modal from "../../components/modal/modal";

const CaseStudy = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [inFocus, setInFocus] = useState("");
  const [modal, setModal] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    getAllApi("caseStudy")
      .then((response) => {
        setBlogs(
          response.data.map((v) => ({
            ...v,
            id: v._id,
            live_link: `https://girnarsoft-web.vercel.app/case-studies/${v.metaData.slug}`,
          }))
        );
        console.log(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setBlogs([]);
        setLoading(false);
        toast.error("Not Found.");
      });
  };

  const handleDelete = () => {
    setModal(false);
    const promise = new Promise((resolve, reject) => {
      deleteByIdApi("caseStudy", inFocus)
        .then((res) => {
          setInFocus("");
          resolve(true);
        })
        .catch((err) => {
          reject();
        });
    });

    toast
      .promise(
        promise,
        {
          loading: "Deleting...",
          success: "Deleted Successfully.",
          error: "Error when deleting the entry.",
        },
        { success: { duration: 2000 }, error: { duration: 2000 } }
      )
      .then(() => {
        getData();
      });
  };

  return (
    <>
      <Modal
        title={"Delete"}
        description={
          "Do you really want to delete this record? This process cannot be undone."
        }
        onBtn1Click={() => {
          setModal(false);
          setInFocus("");
        }}
        onBtn2Click={handleDelete}
        state={modal}
      />
      <WithTableView
        heading="Case Study"
        head={[
          { title: "S.No." },
          { title: "Title" },
          { title: "" },
          { title: "" },
        ]}
        body_keys={["title", "live_link", "action:delete"]}
        body={blogs}
        show_btn_1={true}
        isIcon={true}
        iconType="add"
        btn1Text={"Case Study"}
        btn1Type={"filled"}
        onClickHandler={() => {
          navigate("/case-study/add");
        }}
        onRowClick={(id) => {
          navigate("/case-study/" + id._id);
        }}
        onActionClick={(id, val) => {
          setInFocus(val);
          setModal(true);
        }}
        loading={loading}
        customElement={<></>}
      />
    </>
  );
};

export default CaseStudy;
